<div class="w-[750px] h-[600px] max-[480px]:w-screen max-[480px]:h-screen p-10 rounded-none">
  <div class="flex justify-between">
    <span
      class="app__form--attribute--title flex justify-between relative text-2xl leading-9 text-[#010B18 m-0"
      style="width: -webkit-fill-available"
    >
      {{ data.type ? data?.type : (data?.form_name | titlecase) }}
    </span>
    <button class="close" type="button" data-dismiss="modal" (click)="closeDialog()">
      <span class="material-icons relative text-[30px] text-[#707070] font-semibold leading-9">close</span>
    </button>
  </div>
  <hr />
  <div>
    <span class="app__centered-item"> <img style="height: 190px; margin-top: 48px" [src]="'assets/images/inaccessible-wall.svg'" /> </span>
    <div class="app__centered-item text-center">
      <div class="mt-2">
        <p class="app__form--attribute--title text-2xl leading-[26.4px]">This is not accessible yet</p>
        <p class="app__form--attribute--title font-semibold text-[#707070]">You will receive access to this in the future</p>
      </div>
    </div>
  </div>
</div>
